import { createContext, ReactNode, useContext } from "react"

import { ApiTypes } from "types"

interface CustomerDashboardContextType {
  devices: ApiTypes.Model.Device[]
  currentDevice: number
  setCurrentDevice: (index: number) => void
  isSidebarOpen: boolean
  customer: ApiTypes.Model.ClientDevices | null
  onUpdateSuccess: () => void
  highlightTransfer: boolean
  setHighlightTransfer: (value: boolean) => void
}

const CustomerDashboardContext = createContext<CustomerDashboardContextType | undefined>(undefined)

export const useCustomerDashboard = () => {
  const context = useContext(CustomerDashboardContext)
  if (!context) {
    throw new Error("useCustomerDashboard must be used within CustomerDashboardProvider")
  }
  return context
}

interface CustomerDashboardProviderProps {
  children: ReactNode
  devices: ApiTypes.Model.Device[]
  currentDevice: number
  setCurrentDevice: (index: number) => void
  isSidebarOpen: boolean
  customer: ApiTypes.Model.ClientDevices | null
  onUpdateSuccess: () => void
  highlightTransfer: boolean
  setHighlightTransfer: (value: boolean) => void
}

export const CustomerDashboardProvider = ({
  children,
  devices,
  currentDevice,
  setCurrentDevice,
  isSidebarOpen,
  customer,
  onUpdateSuccess,
  highlightTransfer,
  setHighlightTransfer,
}: CustomerDashboardProviderProps) => {
  return (
    <CustomerDashboardContext.Provider
      value={{
        devices,
        currentDevice,
        setCurrentDevice,
        isSidebarOpen,
        customer,
        onUpdateSuccess,
        highlightTransfer,
        setHighlightTransfer,
      }}
    >
      {children}
    </CustomerDashboardContext.Provider>
  )
}
